import { BarDatum, BarTooltipProps, ResponsiveBarCanvas } from '@nivo/bar';
import { useTranslation } from 'react-i18next';
import {
  applyColorOpacity,
  getBestContrastColor,
  getQualitativeColor,
} from '../../common/color.helper';
import ChartTooltip from '../panels/ChartTooltip';

export type DockUsageDatum = BarDatum & {
  hour: string;
  [key: string]: string | number;
};

export type DockUsageChartProps = {
  data: DockUsageDatum[];
  docks: string[];
  hiddenDocks?: Set<string>;
};

const DockUsageChartTooltip: React.FC<BarTooltipProps<DockUsageDatum>> = ({
  id,
  value,
  color,
  data,
}) => (
  <ChartTooltip
    title={id.toString()}
    value={`${value} jobs`}
    color={[color, getBestContrastColor(color)]}
    subTitle={data.hour}
  />
);

const DockUsageChart: React.FC<DockUsageChartProps> = ({
  data,
  docks,
  hiddenDocks,
}) => {
  const { t } = useTranslation('simulation');

  return (
    <div style={{ height: 400 }} className="h-full w-full">
      <ResponsiveBarCanvas
        data={data}
        keys={docks}
        indexBy="hour"
        margin={{ top: 20, right: 30, bottom: 100, left: 60 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={({ id }) => {
          const color = getQualitativeColor(id as string, 'policy')[0];
          if (hiddenDocks?.has(id as string)) {
            return applyColorOpacity(color, 0.5);
          }
          return color;
        }}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 90,
          // legend: t('Time (Hour)'),
          legendPosition: 'middle',
          legendOffset: 50,
          format: v => v,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: t('Number of Jobs'),
          legendPosition: 'middle',
          legendOffset: -50,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
        tooltip={DockUsageChartTooltip}
        // legends={[
        //   {
        //     dataFrom: 'keys',
        //     anchor: 'bottom-right',
        //     direction: 'column',
        //     justify: false,
        //     translateX: 120,
        //     translateY: 0,
        //     itemsSpacing: 1,
        //     itemWidth: 100,
        //     itemHeight: 20,
        //     itemDirection: 'left-to-right',
        //     itemOpacity: 0.1,
        //     symbolSize: 20,
        //     effects: [
        //       {
        //         on: 'hover',
        //         style: {
        //           itemOpacity: 1,
        //         },
        //       },
        //     ],
        //   },
        // ]}
        theme={{
          axis: {
            ticks: {
              text: {
                fontSize: Math.max(7, Math.min(12)),
                fill: 'rgba(255, 255, 255, 0.8)',
              },
            },
          },
          grid: {
            line: {
              stroke: 'rgba(255, 255, 255, 0.2)',
            },
          },
        }}
      />
    </div>
  );
};

export default DockUsageChart;
